<template>
  <div>
    <sl-alert v-show="showWelcome" dismissible type="info" @input="showWelcomeOnDismiss">
      Welcome to Sharylist! <br />
      You can find an introductory tutorial here, in your Personal Workspace, by clicking on the
      "Click here to start" model, below.
    </sl-alert>
    <v-card v-if="userAuthorized" flat>
      <v-card-subtitle class="py-0 text-overline">
        Browse checklists and models
      </v-card-subtitle>

      <v-card flat>
        <v-card-title class="pb-0">
          <v-icon color="instance" left>mdi-format-list-checks</v-icon>
          Recently changed checklists
        </v-card-title>
        <v-progress-linear
          :active="loadingInstances"
          indeterminate
          color="instance"
        ></v-progress-linear>
        <!-- <sl-progress v-show="loadingInstances" color="instance"></sl-progress> -->
        <v-container fluid>
          <v-row v-show="!loadingInstances" align="start" justify="start">
            <v-col
              v-for="instance in recentInstances.slice(0, 4)"
              :key="instance.id"
              xs="12"
              sm="4"
              md="3"
            >
              <!-- ------------- COMPONENT --------------- -->
              <instance-card :instance="instance" />
              <!-- ------------ / COMPONENT -------------- -->
            </v-col>
            <v-col v-if="recentInstances.length == 0" xs="12" sm="12" md="6" lg="6">
              <v-alert outlined icon="mdi-emoticon-sad-outline" elevation="0" color="grey" dense>
                <p>
                  <span class="font-weight-medium">No checklists yet.</span>
                  <br />
                  Choose or create a new model to add checklists.
                </p>
              </v-alert>
            </v-col>
          </v-row>
        </v-container>
      </v-card>

      <v-card flat>
        <v-card-title class="pb-0">
          <v-icon color="master" left>mdi-vector-square</v-icon>
          Workspace models
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-on="on" v-bind="attrs">
                <v-btn
                  :disabled="workspaceMastersNumberMaxReached"
                  :icon="$vuetify.breakpoint.xsOnly"
                  outlined
                  color="master"
                  class="mx-1"
                  @click="masterCreateNew"
                >
                  <v-icon :left="$vuetify.breakpoint.smAndUp">
                    mdi-plus
                    <!-- {{ $vuetify.breakpoint.xsOnly ? 'mdi-plus' : 'mdi-vector-square' }} -->
                  </v-icon>
                  <span v-if="$vuetify.breakpoint.smAndUp">New model</span>
                </v-btn>
              </span>
            </template>
            <span v-if="workspaceMastersNumberMaxReached">
              Sorry, you have reached the maximum number ({{
                userLogged.usageLimits.workspaceMastersNumberMax
              }}) of models per workspace allowed by your current plan; contact us to extend this
              limit
            </span>
            <span v-else> Create a new model </span>
          </v-tooltip>
          <v-tooltip v-if="(mastersViewToggle || mastersViewDefault) === 'cards'" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                class="mx-1"
                v-bind="attrs"
                v-on="on"
                @click="mastersViewToggle = 'table'"
              >
                <v-icon>mdi-view-headline</v-icon>
              </v-btn>
            </template>
            <span>Table view</span>
          </v-tooltip>
          <v-tooltip v-else-if="(mastersViewToggle || mastersViewDefault) === 'table'" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                class="mx-1"
                v-bind="attrs"
                v-on="on"
                @click="mastersViewToggle = 'cards'"
              >
                <v-icon>mdi-view-grid-outline</v-icon>
              </v-btn>
            </template>
            <span>Cards view</span>
          </v-tooltip>
          <!-- <v-btn-toggle v-model="mastersViewToggle" background-color="white" mandatory>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-view-headline</v-icon>
                </v-btn>
              </template>
              <span>Table view</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on">
                  <v-icon>mdi-view-grid-outline</v-icon>
                </v-btn>
              </template>
              <span>Cards view</span>
            </v-tooltip>
          </v-btn-toggle> -->
        </v-card-title>
        <v-progress-linear
          :active="loadingMasters"
          indeterminate
          color="master"
        ></v-progress-linear>

        <!-- TABLE VIEW -->
        <template v-if="(mastersViewToggle || mastersViewDefault) === 'table'">
          <v-container fluid>
            <v-row>
              <v-col>
                <v-card>
                  <v-card-title>
                    <!-- Models -->
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-on="on" v-bind="attrs">
                          <v-btn
                            v-if="$vuetify.breakpoint.smAndUp"
                            :disabled="workspaceMastersNumberMaxReached"
                            icon
                            outlined
                            color="master"
                            @click="masterCreateNew"
                          >
                            <v-icon> mdi-plus </v-icon>
                          </v-btn>
                        </span>
                      </template>
                      <span v-if="workspaceMastersNumberMaxReached">
                        Sorry, you have reached the maximum number ({{
                          userLogged.usageLimits.workspaceMastersNumberMax
                        }}) of models per workspace allowed by your current plan; contact us to
                        extend this limit
                      </span>
                      <span v-else> Create a new model </span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="mastersTableSearch"
                      append-icon="mdi-magnify"
                      label="Search in model titles"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                  <v-data-table
                    :headers="mastersTableHeaders"
                    :items="masters"
                    :items-per-page="10"
                    :search="mastersTableSearch"
                    :loading="loadingMasters"
                    loading-text="Loading... Please wait"
                    @click:row="goToMaster($event)"
                  >
                    <!-- :loading="loadingMasters" -->
                    <v-progress-linear
                      v-show="loadingMasters"
                      slot="progress"
                      color="master"
                      indeterminate
                    ></v-progress-linear>
                    <template v-slot:item.title="{ item }">
                      <span class="font-weight-medium master--text">
                        <sl-text-truncated :text="item.title" :lengthMax="titleCharsShownMax" />
                      </span>
                    </template>
                    <template v-slot:item.createdBy="{ item }">
                      <sl-text-truncated
                        :text="item.creator.firstName"
                        :lengthMax="nameCharsShownMax"
                      />
                      <sl-text-truncated
                        :text="item.creator.lastName"
                        :lengthMax="nameCharsShownMax"
                      />
                    </template>
                    <template v-slot:item.createdAt="{ item }">
                      <sl-time :time="item.createdAt" dateOnly />
                    </template>
                    <template v-slot:item.instancedBy="{ item }">
                      <template v-if="item.lastInstance">
                        <sl-text-truncated
                          :text="item.lastInstance.creator.firstName"
                          :lengthMax="nameCharsShownMax"
                        />
                        <sl-text-truncated
                          :text="item.lastInstance.creator.lastName"
                          :lengthMax="nameCharsShownMax"
                        />
                      </template>
                      <template v-else>
                        –
                      </template>
                    </template>
                    <template v-slot:item.instancedAt="{ item }">
                      <template v-if="item.lastInstance">
                        <sl-time :time="item.lastInstance.createdAt" />
                      </template>
                      <template v-else>
                        –
                      </template>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <sl-btn-instance-create
                        icon
                        iconAlternative
                        color="instance"
                        :master="item"
                      />
                      <sl-btn-master-duplicate :master="item" />
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            v-bind="attrs"
                            v-on="on"
                            @click.stop="openMasterInNewTab(item)"
                          >
                            <v-icon>mdi-open-in-new</v-icon>
                          </v-btn>
                        </template>
                        <span>Open model in a new tab</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </template>

        <!-- CARDS VIEW -->
        <template v-else-if="(mastersViewToggle || mastersViewDefault) === 'cards'">
          <!-- <sl-progress v-show="loadingMasters" color="master"></sl-progress> -->
          <v-container v-show="!loadingMasters" fluid>
            <v-row align="start" justify="start">
              <v-col v-for="master in masters" :key="master.id" xs="12" sm="4" md="3">
                <!-- ------------- COMPONENT --------------- -->
                <master-card :master="master" />
                <!-- @instanceCreate="instanceCreateNew(master)"
                  @masterDuplicate="masterDuplicate(master)" -->
                <!-- ------------ / COMPONENT -------------- -->
              </v-col>
              <v-col v-if="masters.length == 0" xs="12" sm="12" md="6" lg="6">
                <v-alert outlined icon="mdi-emoticon-sad-outline" elevation="0" color="grey" dense>
                  <p>
                    <span class="font-weight-medium">No models yet.</span>
                    <br />
                    Press the '+' button, to create your first model.
                  </p>
                </v-alert>
              </v-col>
            </v-row>
          </v-container>
        </template>
      </v-card>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Logger from '@/lib/Logger'

import Session from '@/models/Session'
import Workspace from '@/models/Workspace'
import ClMaster from '@/models/ClMaster'
// import ClInstance from '@/models/ClInstance'

import SlAlert from '@/components/SlAlert'
import InstanceCard from '@/components/InstanceCard'
import MasterCard from '@/components/MasterCard'
// import SlProgress from '@/components/SlProgress'
import SlBtnMasterDuplicate from '@/components/SlBtnMasterDuplicate'
import SlBtnInstanceCreate from '@/components/SlBtnInstanceCreate'
import SlTime from '@/components/SlTime'
import SlTextTruncated from '@/components/SlTextTruncated'

export default {
  components: {
    InstanceCard,
    MasterCard,
    SlAlert,
    SlBtnMasterDuplicate,
    SlBtnInstanceCreate,
    SlTime,
    SlTextTruncated,
    // SlProgress,
  },

  data() {
    return {
      workspace: {},
      masters: [],
      mastersTableSearch: '',
      mastersTableHeaders: [
        {
          text: 'Title',
          align: 'start',
          value: 'title',
        },
        { text: 'Created by', value: 'createdBy' },
        { text: 'Created on', value: 'createdAt' },
        { text: 'Last checklist by', value: 'instancedBy' },
        { text: 'Last checklist at', value: 'instancedAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      instancesOpenTableSearch: '',
      nameCharsShownMax: 16,
      titleCharsShownMax: 32,
      recentInstances: [],
      loadingInstances: true,
      loadingMasters: true,
      userAuthorized: true,
      showWelcome: false,
      mastersViewToggle: '',
    }
  },
  watch: {
    async $route(/*to, from*/) {
      // react to route changes...
      this.queries.forEach(q => q.destroy())
      this.queryCreate()
      try {
        await Session.setWorkspaceId(this.$route.params.workspaceId)
      } catch (e) {
        Logger.error('ERRORE:', e)
      }
    },
  },
  computed: {
    mastersViewDefault() {
      if (this.masters.length === 0) return ''
      else if (this.masters.length <= 8) return 'cards'
      else return 'table'
    },
    workspaceMastersNumberMaxReached() {
      return !this.workspace?.actionsAllowed?.masterCreate
    },
    ...mapState({
      workspaceId: state => state.nodeCurrent.workspace.id,
      userLogged: state => state.userLogged,
    }),
  },

  async created() {
    Logger.debug('--------------> Dashboard.created()')
    this.errorsDataAccessAllSetFalse()
    this.queryCreate()
    try {
      await Session.setWorkspaceId(this.$route.params.workspaceId)
    } catch (e) {
      Logger.error('ERRORE:', e)
    }
    this.showWelcome =
      Session.data.showWelcome &&
      this.$route.params.workspaceId === Session.data.personalWorkspaceId
  },

  mounted() {
    Logger.debug('--------------> Dashboard.mounted()')
  },

  beforeDestroy() {
    this.queries.forEach(q => q.destroy())
  },

  methods: {
    queryCreate() {
      if (this.queries) this.queries.forEach(q => q.destroy())
      this.queries = [
        Workspace.find({
          get: `{
                id,
                name,
                actionsAllowed {
                  masterCreate
                },
                recentInstances{
                  id,
                  title,
                  archived,
                  clMaster {
                    id, title
                  },
                  creator {
                    id, firstName, lastName
                  },
                  createdAt,
                  lastEntryUpdate {
                    user {
                      id, firstName, lastName
                    },
                    time
                  },
                  currentlyOnUsers {
                    id, firstName, lastName
                  },
                  clInstanceEntries {
                    id,
                    checked
                  }
                }
                clMasters {
                  id,
                  title,
                  createdAt,
                  creator {
                    id, firstName, lastName
                  },
                  workspace {
                    id, name
                  },
                  actionsAllowed {
                    instanceCreate,
                    selfDuplicate
                  },
                  instancesNumber,
                  lastInstance {
                    id,
                    title,
                    creator {
                      id, firstName, lastName
                    },
                    createdAt,
                  },
                }
              }`,
          by: { id: this.$route.params.workspaceId },
          onChange: data => {
            this.errorsDataAccessAllSetFalse()
            this.nodeCurrentSet({
              workspace: {
                id: data.id,
                name: data.name,
              },
            })
            this.workspace = data
            this.masters = data.clMasters
            this.loadingMasters = false
            this.recentInstances = data.recentInstances.filter(instance => !instance.archived)
            /* this.recentInstances.forEach(instance => {
              if (instance.currentlyOnUsers.length > 0) {
                instance.userOnLast =
                  instance.currentlyOnUsers[instance.currentlyOnUsers.length - 1]
              } else {
                instance.userOnLast = null
              }
            }) */
            this.loadingInstances = false
          },
          onError: error => {
            this.loadingMasters = false
            this.loadingInstances = false
            Logger.error('ERROR in loading data:', error)
            switch (error.name) {
              case 'UNAUTHORIZED_TO_WORKSPACE':
                this.errorDataUnauthorizedAccessSet(true)
                this.userAuthorized = false
                Session.clear()
                break
              case 'WORKSPACE_MISSING':
                this.errorDataMissingSet(true)
                Session.clear()
                break
              default:
                this.toastSet({
                  message: 'Error in loading data',
                  color: 'error',
                })
            }
          },
        }),
      ]
    },

    goToMaster(master) {
      this.$router.push({ path: '/model/' + master.id })
    },

    openMasterInNewTab(master) {
      const route = this.$router.resolve({ path: '/model/' + master.id })
      window.open(route.href, '_blank')
    },

    showWelcomeOnDismiss() {
      Session.data.showWelcome = false
      try {
        Session.save()
      } catch (e) {
        Logger.error(e)
      }
    },

    async masterCreateNew() {
      const masterNew = {
        title: 'New model ' + Date.now(), //NB: ho usato spazi speciali no-break
        workspaceId: this.workspaceId,
      }
      try {
        const masterNewRes = await ClMaster.create(masterNew)
        this.$router.push({ path: '/model/' + masterNewRes.id })
        // this.$router.push({ name: 'Master', params: { masterId: masterNewId } })
      } catch (e) {
        Logger.error(e)
        this.toastSet({
          message: 'Error in creating a new model',
          color: 'error',
        })
      }
    },
    ...mapMutations([
      'nodeCurrentSet',
      'toastSet',
      'errorDataUnauthorizedAccessSet',
      'errorDataMissingSet',
      'errorsDataAccessAllSetFalse',
    ]),
  },
}
</script>

<style scoped>
/* .table-cursor tbody tr:hover {
  cursor: pointer;
} */
</style>
